import type { IconComponent } from "@overmap-ai/blocks"

import { FormSubmissionTimelineItemType } from "../enums/forms"
import { modelIconMapping } from "./icons"

export const formSubmissionTimelineItemTypeData: Record<
	FormSubmissionTimelineItemType,
	{ icon: IconComponent; label: string }
> = {
	[FormSubmissionTimelineItemType.CREATED]: {
		icon: modelIconMapping.form,
		label: "Submitted",
	},
	[FormSubmissionTimelineItemType.COMMENT]: {
		icon: modelIconMapping.comment,
		label: "Comments",
	},
	[FormSubmissionTimelineItemType.FIELD_VALUES]: {
		icon: modelIconMapping.edit,
		label: "Field values",
	},
	[FormSubmissionTimelineItemType.IDENTIFIER_VALUE]: {
		icon: modelIconMapping.identifier,
		label: "Identifiers",
	},
}
